import { DOWNLOAD_STATUS } from 'components/DownloadBlock/constants';
import { OFFER_STATUS } from 'modules/Offers/InquiryOffersSection/constants';

export const DOWNLOAD_STATUS_TO_OFFER = {
  [OFFER_STATUS.ACCEPTED]: DOWNLOAD_STATUS.DOWNLOADED,
  [OFFER_STATUS.NEW]: DOWNLOAD_STATUS.NOT_DOWNLOADED,
  [OFFER_STATUS.DOWNLOADED]: DOWNLOAD_STATUS.DOWNLOADED,
  [OFFER_STATUS.PENDING]: DOWNLOAD_STATUS.NOT_DOWNLOADED,
};
